import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'

const StyledButton = ({
  className,
  text,
  external,
  title,
  internal,
  submit,
  hover = true,
  ...props
}) => {
  let styles = `bg-gold rounded text-black border-none text-black [&>a]:w-full [&>a]:block w-[200px] py-2 [&>span]:text-black [&>a>span]:font-bold [&>a>span]:uppercase [&>a]:no-underline  cursor-default hover:bg-white	 ${
    hover && 'buttonHover cursor-pointer'
  }`
  styles += className ? ` ${className}` : ''
  if (external) {
    const { href } = props
    return (
      <button type="button" className={styles}>
        <a href={href} target="_blank" rel="noreferrer">
          {title && <span className="sr-only">{title}</span>}
          <span>{text}</span>
        </a>
      </button>
    )
  }
  if (submit) {
    const { href } = props
    return (
      <button type="submit" className={styles} {...props}>
        <span className="uppercase font-bold text-[18px]">{text}</span>
      </button>
    )
  }
  if (internal) {
    const { to } = props
    return (
      <button type="button" className={styles}>
        <Link to={to}>
          {title && <span className="sr-only">{title}</span>}
          <span>{text}</span>
        </Link>
      </button>
    )
  }

  return (
    <button type="button" className={styles}>
      <a {...props}>
        {title && <span className="sr-only">{title}</span>}
        <span>{text}</span>
      </a>
    </button>
  )
}

StyledButton.propTypes = {
  className: PropTypes.any,
  download: PropTypes.string,
  external: PropTypes.bool,
  href: PropTypes.string,
  submit: PropTypes.bool,
  internal: PropTypes.bool,
  text: PropTypes.string,
  title: PropTypes.any,
  to: PropTypes.string,
}

export default StyledButton
